"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoPlayer = getVideoPlayer;
var environment_1 = require("../../config/environment");
/**
 * Get the first video.js player instance from the page.
 *
 * Returns null if:
 * - Not in browser environment
 * - video.js is not loaded
 * - No players exist on the page
 */
function getVideoPlayer() {
    var _a;
    if (!(0, environment_1.isBrowser)())
        return null;
    var videojs = window.videojs;
    if (!(videojs === null || videojs === void 0 ? void 0 : videojs.getAllPlayers))
        return null;
    var players = videojs.getAllPlayers();
    if (!players || players.length === 0)
        return null;
    return (_a = players[0]) !== null && _a !== void 0 ? _a : null;
}
